var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"40px"}},[_vm._m(0),_c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('CardItem',{key:item.id,attrs:{"info":item}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"textNew"},[_vm._v("名师带练")]),_c('div',{staticClass:"text"},[_vm._v("高效练习不走弯路")])])
}]

export { render, staticRenderFns }